import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import FoodBankIcon from "@mui/icons-material/FoodBank";

import "react-phone-number-input/style.css";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import Icon from "@mdi/react";
import { mdiHandHeart } from "@mdi/js";

let env = require("./../../../../env");

// props has activeStep
export default function DonationButtonElement({ setShowDrawerMenu }) {
  const {} = useContext(KioskContext);

  const { qrCode, getKioskTheme } = useContext(SocketIOContext);

  const kiosktheme = getKioskTheme();
  const kioskstyles = useKioskHorizontalStyles();

  return (
    <div
      class="ks_blackCornedDiv ks_blackCornedDivMarginForSubtitle"
      style={{
        ...kioskstyles.quickDonationDiv,
        ...kioskstyles.blackCornedDivMarginForSubtitle
      }}
      onClick={() => setShowDrawerMenu(true)}
    >
      <div
        class="ks_row"
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%"
        }}
      >
        <div
          id="charitybutton"
          style={kioskstyles.phonenumber.donationButtonIcon}
        >
          {/* <FoodBankIcon sx={{ width: "16vh", height: "8vh" }} /> */}
          <Icon path={mdiHandHeart} size={"8vh"} />
        </div>
        <div style={kioskstyles.phonenumber.quickdonationdiv}>
          <span class="fontBold" style={kioskstyles.phonenumber.qrtitleelement}>
            <Translate value="application.theme.donationHeader" />
          </span>
          <span
            class="fontNormal"
            style={kioskstyles.phonenumber.qrbodyelement}
          >
            <Translate value="application.theme.donationBody" />
          </span>
        </div>
      </div>
    </div>
  );
}
